import React, { useContext, useEffect, useState } from "react";
import {
  Loader,
  TextButton,
  useIcon,
  TextInput,
  ModalContext,
  ModalButtonsContainer,
} from "@SeemplicityDev/shared";
import CustomerDataSourceDefItem from "./CustomerDataSourceDefItem/CustomerDataSourceDefItem";
import { useQuery } from "@apollo/client";
import {
  CNC_GET_DATASOURCES,
  type CncDatasourceNode,
  type CncGetDatasourcesData,
  type CncGetDatasourcesVariables,
} from "../CustomerProvisioningApi";
import "./CustomerDataSources.scss";

type InstancesByDSType = Record<string, CncDatasourceNode[]>;

interface CustomerDataSourcesProps {
  accountUuid: string;
  accountName: string;
}

const CustomerDataSources: React.FC<CustomerDataSourcesProps> = ({
  accountUuid,
  accountName,
}) => {
  const { getSvg } = useIcon();
  const { data: customerDSData } = useQuery<
    CncGetDatasourcesData,
    CncGetDatasourcesVariables
  >(CNC_GET_DATASOURCES, {
    fetchPolicy: "no-cache",
    variables: {
      account_uuid: accountUuid,
    },
  });
  const { closeModal } = useContext(ModalContext);
  const [instancesByDSType, setInstancesByDSType] = useState<
    InstancesByDSType | undefined
  >();
  const [instancesToShow, setInstancesToShow] = useState<
    InstancesByDSType | undefined
  >();
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    if (!!customerDSData) {
      const formattedDS: InstancesByDSType = {};
      customerDSData?.cnc_datasources?.edges?.forEach((instance) => {
        const DSName = instance.node?.datasource_definition?.name;
        if (!!formattedDS[DSName]) {
          formattedDS[DSName].push(instance.node);
        } else {
          formattedDS[DSName] = [instance.node];
        }
      });

      setInstancesByDSType(formattedDS);
      setInstancesToShow(formattedDS);
    }
  }, [customerDSData]);

  useEffect(() => {
    if (!!instancesByDSType) {
      const filteredDS = Object.keys(instancesByDSType)
        .filter((dsType) =>
          dsType.toLowerCase().includes(searchTerm.toLowerCase())
        )
        .reduce<InstancesByDSType>((obj, key) => {
          obj[key] = instancesByDSType[key];
          return obj;
        }, {});

      setInstancesToShow(filteredDS);
    }
  }, [searchTerm]);

  return (
    <div>
      <div className={"ds-list-wrap"}>
        {!!instancesToShow ? (
          <>
            <TextInput
              data-testid={"search-ds-input"}
              placeholder={"Type to search..."}
              isClearable
              leftIcon={"seem-icon-search"}
              value={searchTerm}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                setSearchTerm(e.target.value)
              }
            />
            <ul>
              {Object.keys(instancesToShow).map((dsType) => {
                return (
                  <li key={dsType}>
                    <CustomerDataSourceDefItem
                      accountUuid={accountUuid}
                      accountName={accountName}
                      DSType={dsType}
                      instances={instancesByDSType![dsType]}
                    />
                  </li>
                );
              })}
            </ul>
          </>
        ) : (
          <Loader center img={getSvg("icon-spinner")} iconSize={"xxxxl"} />
        )}
      </div>
      <ModalButtonsContainer centerButtons>
        <TextButton
          type="button"
          data-testid={""}
          label={"Close"}
          onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
            e.stopPropagation();
            closeModal();
          }}
        />
      </ModalButtonsContainer>
    </div>
  );
};
export default CustomerDataSources;
